import ENDPOINTS from "@/app/constants/api/api"
import { apiGet } from "@/lib/api"
import type { AllExchangesResponse } from "@/app/components/AllExchanges/allExchanges.interface"

export const getAllExchanges = async (coin: string) => {
	return apiGet<AllExchangesResponse>(ENDPOINTS.ALL_EXCHANGES, {
		symbol: coin,
		currency: "IRT",
	})
}

export type CoinPdp = {
	token_symbol: string
	description: string
}

export const getCoinPdp = (symbol: string) =>
	apiGet<{ message: CoinPdp[] }>(`${ENDPOINTS.COIN_PDP}/${symbol.toUpperCase()}/`)

export type ExchangePdp = { exchange: string; description: string; name: string }

export const getExchangePdp = (exchange: string) =>
	apiGet<{ message: Record<string, ExchangePdp> }>(`${ENDPOINTS.COIN_EXCHANGE_PDP}/${exchange.toUpperCase()}/`)

export const getExchangeNames = () => apiGet<Record<string, unknown>>(ENDPOINTS.MARKET_EXCHANGE_NAMES)

export const getCoinExchangePdp = (exchange: string, coin: string) =>
	apiGet<{ message: Record<string, ExchangePdp> }>(
		`${ENDPOINTS.COIN_EXCHANGE_DETAIL_PDP}/${exchange.toUpperCase()}/${coin.toUpperCase()}`,
	)
